export const aboutDefaults = {
  title: "About Legends Poker",
  subtitle: "Victoria's home for competitive, community-driven poker.",
  hero_image: "https://images.unsplash.com/photo-1511193311914-0346f16efe90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  story_eyebrow: "Our Story",
  story_title: "Poker, done properly.",
  story_p1:
    "Legends Poker was founded to give Victorian players a serious, well-run circuit close to home. We host regular tournaments at trusted venues across the state, track every result, and reward consistency with a season-long points race.",
  story_p2:
    "Whether you're chasing the Championship trophy or just want a great night at the felt, you'll find fair structures, professional dealers, and a welcoming community. Play enough, play well, and you'll qualify for the Main Event — where legends are made.",
  story_image: "https://images.unsplash.com/photo-1446669052213-5dcff53f1f3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  cards: [
    { title: "Season Championships", desc: "Points-based qualification to the annual Main Event." },
    { title: "Fair Structures", desc: "Consistent, published tournament rules and clocks." },
    { title: "Responsible Gaming", desc: "18+, ID checks, and player wellbeing first." },
    { title: "Real Community", desc: "A friendly, competitive crowd across Victoria." },
  ],
  cta_title: "Ready to take your seat?",
  cta_text: "Join the league and start climbing the leaderboard tonight.",
};

export const becomeLegendDefaults = {
  title: "Become a Legend",
  subtitle: "Join the league, earn your points, and chase a seat at the Championship Main Event.",
  image: "https://images.unsplash.com/photo-1511193311914-0346f16efe90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blurb:
    "Becoming a Legend is simple. Register your interest below and we'll set you up with a player profile, add you to your local venue's leaderboard, and send you the schedule.",
};

export const contactDefaults = {
  title: "Contact Us",
  subtitle: "Questions about events, membership or hosting? Drop us a line — we're happy to help.",
  image: "https://images.unsplash.com/photo-1626775238053-4315516eedc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  blurb: "Fill in the form below and the League Committee will respond within two business days. You can also reach us directly using the details here.",
  email: "play@legendspoker.com.au",
  phone: "(03) 9000 0000",
  base: "Melbourne, Victoria",
  facebook: "",
  instagram: "",
};

export const becomeHostDefaults = {
  title: "Become a Host Venue",
  subtitle: "Bring competitive, professionally-run poker nights to your venue and grow your midweek trade.",
  image: "https://images.pexels.com/photos/35447980/pexels-photo-35447980.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600",
  blurb:
    "Hosting Legends events fills your room on quiet nights with a loyal, sociable crowd who eat and drink while they play. We bring the tables, dealers, structure and marketing — you provide the space. Register your venue's interest below and our partnerships team will be in touch.",
};
